<div class="app-wrapper">
  <div *ngIf="showTestBanner" class="test-banner" role="status" aria-live="polite">
    <span class="test-banner__icon">⚠</span>
    Ambiente de pruebas
  </div>
  <router-outlet></router-outlet>
</div>

